import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { Helmet } from 'react-helmet';
import favicon from "../assets/favicon.ico";
import SchemaMarkupComponent from "../components/SchemaMarkupComponent.jsx";
import uiux from "../assets/ui_ux_home1.jpg";
import software_home from "../assets/software_home.jpg";
import marketing from "../assets/marketing_home.jpg";
import image5 from "../assets/homepage_lastimage.jpg";

const ContactUs = () => {
  const metaUrl = "https://www.techecosolution.in/contact-tes";
  const services = [
    { 
      title: "UI/UX Design", 
      image: uiux,
      description: "Professional UI/UX design services for modern web applications"
    },
    { 
      title: "Web Development", 
      image: software_home,
      description: "Full-stack web development solutions using latest technologies"
    },
    { 
      title: "Digital Marketing", 
      image: marketing,
      description: "Complete digital marketing and SEO services to grow your business"
    },
  ];

  // Enhanced Schema Markup
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Techecosolution (TES)",
    "alternateName": "TES",
    "url": metaUrl,
    "logo": `${metaUrl}${favicon}`,
    "description": "Techecosolution (TES) - Your partner for web development software development & digital marketing solutions.",
    "foundingDate": "2020",
    "founder": {
      "@type": "Person",
      "name": "TES Founder"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9483085077",
      "contactType": "customer service",
      "availableLanguage": ["English", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/techecosolution",
      "https://www.linkedin.com/company/techecosolution",
      "https://twitter.com/techecosolution"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "150"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Techecosolution",
    "url": metaUrl,
    "description": "Techecosolution (TES) - Your partner for web development, software development & digital marketing solutions.",
    "publisher": {
      "@type": "Organization",
      "name": "Techecosolution"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${metaUrl}search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Web Development & Digital Marketing Services",
    "description": "Techecosolution (TES) - Your partner for web development, software development & digital marketing solutions.",
    "provider": {
      "@type": "Organization",
      "name": "Techecosolution"
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Web Development Services",
      "itemListElement": services.map((service, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": service.title,
          "description": service.description
        }
      }))
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": metaUrl
      }
    ]
  };

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [popup, setPopup] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    emailjs
      .send(
        "service_ymk6pq9", // Replace with your EmailJS Service ID
        "enquryform", // Replace with your EmailJS Template ID
        {
          name: form.name,
          email: form.email,
          phone: form.phone,
          service: form.service,
          message: form.message,
        },
        "H8qppH7v7nvzF5PTr" // Replace with your EmailJS Public Key
      )
      .then(
        (response) => {
          console.log("EmailJS response:", response);
          setPopup("success");
          setSent(true);
        },
        (err) => {
          console.error("EmailJS error:", err);
          setError("Failed to send enquiry. Please try again.");
        }
      );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  return (
    <>
      <SchemaMarkupComponent />
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Get in touch with Techecosolution (TES) for all your needs.</title>
        <meta name="title" content="Get in touch with Techecosolution (TES) for all your needs." />
        <meta name="description" content="Get in touch with Techecosolution (TES) for all your web development, software development & digital marketing needs. We're here to help you grow your business." />
        <meta name="keywords" content="contact Techecosolution, web development India, software development Bangalore, digital marketing services, SEO services India, UI/UX design, responsive website design" />
        <meta name="author" content="Techecosolution Team" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />
        <meta name="distribution" content="web" />
        <meta name="rating" content="general" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Techecosolution" />
        <meta property="og:url" content={metaUrl} />
        <meta property="og:title" content="Contact Techecosolution" />
        <meta property="og:description" content="Get in touch with Techecosolution (TES) for all your web development, software development & digital marketing needs." />
        <meta property="og:image" content={`${metaUrl}${image5}`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Techecosolution Contact Us" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:locale:alternate" content="en_US" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:site" content="@techecosolution" />
        <meta property="twitter:creator" content="@techecosolution" />
        <meta property="twitter:url" content={metaUrl} />
        <meta property="twitter:title" content="Contact Techecosolution" />
        <meta property="twitter:description" content="Get in touch with Techecosolution (TES) for all your web development, software development & digital marketing needs." />
        <meta property="twitter:image" content={`${metaUrl}${image5}`} />
        <meta property="twitter:image:alt" content="Techecosolution Contact Us" />

        {/* Additional SEO Meta Tags */}
        <meta name="theme-color" content="#0e5cae" />
        <meta name="msapplication-TileColor" content="#0e5cae" />
        <meta name="msapplication-config" content="/browserconfig.xml" />
            
        {/* Geo Tags */}
        <meta name="geo.region" content="IN-KA" />
        <meta name="geo.placename" content="Bangalore" />
        <meta name="geo.position" content="12.9716;77.5946" />
        <meta name="ICBM" content="12.9716, 77.5946" />

        {/* Business/Organization Tags */}
        <meta name="business:contact_data:street_address" content="Bangalore, Karnataka" />
        <meta name="business:contact_data:locality" content="Bangalore" />
        <meta name="business:contact_data:region" content="Karnataka" />
        <meta name="business:contact_data:postal_code" content="560001" />
        <meta name="business:contact_data:country_name" content="India" />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* Hreflang Tags */}
        <link rel="alternate" hreflang="en-in" href={metaUrl} />
        <link rel="alternate" hreflang="en-us" href={metaUrl} />
        <link rel="alternate" hreflang="en-gb" href={metaUrl} />
        <link rel="alternate" hreflang="x-default" href={metaUrl} />

        {/* Canonical URL */}
        <link rel="canonical" href={metaUrl} />

        {/* Preconnect for Performance */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="//www.google-analytics.com" />
        <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      </Helmet>

      <div className="bg-black-100 py-16">
        <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Section */}
          <div className="bg-blue-900 text-white mt-10 p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold mt-10 mb-4">Contact</h3>
            <p className="mb-8 ">
              <span className="font-medium">Phone:</span> <a href="tel:+91 9483085077" className="hover:text-blue-300">+91 9483085077</a><br />
              <span className="font-medium">Email:</span> <a href="mailto:contact@techecosolution.in" className="hover:text-blue-300">contact@techecosolution.in</a><br />
              <span className="font-medium">Email:</span> <a href="mailto:techecosolution@gmail.com" className="hover:text-blue-300">techecosolution@gmail.com</a>
            </p>
            <h3 className="text-2xl font-bold mb-4">Business Timings</h3>
            <p className="mb-16">Monday - Friday: 10:00 AM - 8:00 PM</p>
            <h3 className="text-2xl font-bold mb-4">Follow Us</h3>
            <link
              rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
              />
              <div className="flex space-x-8 mt-4">
              <a href="https://www.instagram.com/techecosolution?igsh=anIwM3pqcmx0cXRu" target="_blank" className="text-gray-400 hover:text-red-400">
                  <i className="fab fa-instagram text-3xl"></i>
              </a>
              </div>

          </div>

          {/* Right Section */}
          <div className="bg-white mt-10 p-8 rounded-lg shadow-lg">
            <h2 className="text-3xl ml-28 font-bold mb-8"> <span className="text-blue-500">Get Your Free Quote Today!</span></h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-800 mb-2">Your Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Ex. John Doe"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-600 mb-2">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="example@gmail.com"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                    required
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-600 mb-2">Phone *</label>
                  <input
                    type="text"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="Enter Phone Number"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-600 mb-2">Service *</label>
                  <select
                    name="service"
                    value={form.service}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                    required
                  >
                    <option>Select Services</option>
                    <option>Development</option>
                    <option>Marketing</option>
                    <option>UI/UX Design</option>
                  </select>
                  </div>

              </div>
              <div className="mb-4">
                <label className="block text-gray-600 mb-2">Your Message *</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Enter here.."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
                  rows="2"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-600 text-white py-3 px-6 rounded-lg w-full"
              >
                Send Message
              </button>
            </form>
            {sent && (
              <p className="text-green-500 mt-4" role="alert">
                We have received your details and our team will get back to you shortly. Thank you!
              </p>
            )}
            {error && (
              <p className="text-red-500 mt-4" role="alert">
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;